export default __webpack_public_path__ + "static/media/bocaire2.16d49502.jpg";